import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useIntl } from "react-intl";

//Components
import { Modal, ModalBody, ModalFooter, Button } from "@gpstrackit/react-controls";
import { NotificationManager } from 'Components/Notifications';

//Actions
import {
    scheduledActionsRequest,
    clearRedux,
} from 'Redux/actions';

const DeleteScheduledAction = (props) => {
    const { tableRef } = props;
    const { messages } = useIntl();
    const dispatch = useDispatch();

    const { openModal, loading, result, ids } = useSelector(state => state.deleteScheduledActionRedux);

    const closeModal = () => {
        dispatch(clearRedux("SCHEDULED_ACTIONS"))
    }

    const applyChanges = () => {
        dispatch(scheduledActionsRequest(ids))
    }

    useEffect(() => {
        if (result) {
            if (result?.delete) {
                NotificationManager.success(
                    ids.length === 1 ? messages['delete_scheduled_action_success_message'] : messages['delete_scheduled_actions_success_message'],
                    ids.length === 1 ? messages['delete_scheduled_action_title'] : messages['delete_scheduled_actions_title'],
                    3000
                );
                closeModal();
                tableRef && tableRef?.current?.getData();
            } else if (!result?.delete) {
                NotificationManager.error(
                    ids.length === 1 ? messages['delete_scheduled_action_error_message'] : messages['delete_scheduled_actions_error_message'],
                    ids.length === 1 ? messages['delete_scheduled_action_title'] : messages['delete_scheduled_actions_title'],
                    3000
                );
                dispatch(clearRedux("SCHEDULED_ACTIONS", { result: null }))
            }
        }
    }, [result])

    return (
        <Modal
            open={openModal}
            title={ids.length === 1 ? messages['delete_scheduled_action_title'] : messages['delete_scheduled_actions_title']}
            handleClose={() => closeModal()}
            position="right"
            loading={loading}
            size="small"
        >
            <ModalBody>
                <div style={{ padding: '0 10px' }}>
                    {ids.length === 1 ? messages['delete_scheduled_action_message'] : messages['delete_scheduled_actions_message']}
                </div>
            </ModalBody>
            <ModalFooter>
                <Button
                    className="btn btn-cancel"
                    onClick={() => closeModal()}
                >
                    {messages['common_cancel']}
                </Button>
                <Button
                    className="btn-dark-blue"
                    onClick={() => applyChanges()}
                >
                    {messages['delete']}
                </Button>
            </ModalFooter>
        </Modal>
    )

}

export default DeleteScheduledAction;